import $ from 'jquery';
import tether from 'tether';
import bootstrap from 'bootstrap';
import Modernizr from './modernizr.js';

// important for jQuery to work for other scripts!
global.$ = global.jQuery = require('jquery');

var MobileResponsive = (function() {
    var VisibleState = Object.freeze({
        CLOSED: 0,
        OPEN: 1
    });

    // default inital states
    var ElementState = {
        hamburger: function() {
            if ($('.header__hamburger').attr("aria-expanded","true")) {
                return VisibleState.OPEN;
            } else {
                return VisibleState.CLOSED;
            }
        },
    };

    function isMobileSite() {
        return $('.header__hamburger').is(':visible') || $(window).width() <= 767;
    }

    function setImageAsBackground(thisImage, isBackground){
        // legacy browser support
        // picturefill();

        // fallback to src for browsers without srcset support
        var src = thisImage.prop('currentSrc') || thisImage.prop('src');
        thisImage.css('display', 'none');
        
        // set the background image for the parent
        var $parent = thisImage.parent();
        var windowWidth = $(window).width();
        var windowHeight = $(window).height();
        if(isBackground){
            src += `&ar=${Math.round(windowWidth)}:${Math.round(windowHeight)}`;
        }
        $parent.css('background-image', 'url('+src+')');
    }

    // the actual opening/closing of the hamburger is handled by Bootstrap
    // below is just for animation
    function hamburgerToggleActivated() {
        if ($('.header__hamburger').attr("aria-expanded") == "false") {
            $('.header__hamburger').addClass('header__hamburger--is-active');
        }
        if ($('.header__hamburger').attr("aria-expanded") == "true"){
            $('.header__hamburger').removeClass('header__hamburger--is-active');
        }
    }

    // toggle search bar
    function toggleSearch(){
        if($('#full-screen-search').hasClass('open')){
            $('#full-screen-search').removeClass('open');
            $('body').removeClass('modal-open');
        } else {
            $('#full-screen-search').addClass('open');
            $('body').addClass('modal-open');
            setTimeout(function(){$('#full-screen-search #term').focus();},300);
        }
    }

    function setupMobileResponsive() {
        // setup ancillary event handler for hamburger click
        $('.header__hamburger').on('click', hamburgerToggleActivated);
        $('#header').removeClass('header--slim');

        // floating labels!
        $('.floating-input').keyup(function(){
            var element = $(this).attr('name');
            // hide
            if(!$.trim(this.value).length) {
                $("." + element + "-label").removeClass('floating');
                $(this).removeClass('floating');
            // show labels
            } else {
                $("." + element + "-label").addClass('floating');
                $(this).addClass('floating');
            }
        });

        $(".floating-input").each(function() {
            var element = $(this).attr('name');
            if ($(this).val() != "" || $(this).is('[readonly]') || $(this).is('[disabled]')) {
                $("." + element + "-label").addClass('floating');
                $(this).addClass('floating');
            }
        });
    }

    function setupDesktop(){
        $(window).scroll(function() {
            if ($(document).scrollTop() > 70) {
                $('#header').addClass('header--slim');
            } else if ($(document).scrollTop() < 40)  {
                $('#header').removeClass('header--slim');
            }
        });
    }

    // init the MobileResponsive module
    function init() {
        if (isMobileSite()) {
            setupMobileResponsive();
        } else {
            setupDesktop();
        }

        // prevent dropdown hiding by manually triggering dropdowns
        $('.header__nav .nav-link.dropdown-toggle').on('click', function (e) {
             e.preventDefault();
             $('.header__nav .nav-item').not($(this).parent()).removeClass('show');
             $(this).parent().toggleClass('show');
        });

        // load imgix background imageables
        var $img = $(".imgix-bg");
        if ($img.length) {
            // triggered whenever an image is loaded, including on resize
            $img.each(function(theImage){
                // add crop faces for Mobile
                // if($(this).hasClass('mobile') && isMobileSite()){
                //     var attributes = JSON.parse($(this).attr('ix-params'));
                //     // attributes['crop'] = "faces";
                //     attributes['h'] = 450;
                //     $(this).attr('ix-params',JSON.stringify(attributes));
                // }

                $(this).on('load', function(){
                    // if this is a mobile only pic and we're on a mobile page
                    if($(this).hasClass('mobile-only')){
                        if(isMobileSite()){
                            setImageAsBackground($(this));
                        }
                    // else if this is a desktop only pic and we're on a desktop page
                    } else if ($(this).hasClass('desktop-only')){
                        if(!isMobileSite()){
                            setImageAsBackground($(this));
                        }
                    // else it's a normal pic
                    } else if ($(this).hasClass('isBackground')){
                        setImageAsBackground($(this), true);
                    } else {
                        setImageAsBackground($(this), false);
                    }
                });
            });

            $('.imgix-bg').css('display', 'none'); 
        }

        // toggle search
        $('.header__icons__search').on('click', toggleSearch);
        $('#full-screen-search, #full-screen-search .close').on('click keyup', function(event) {
            if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
                $('#full-screen-search').removeClass('open');
            }
        });

        // fix flex-wrap
        if (Modernizr.flexbox && Modernizr.flexwrap) {
            // Modern Flexbox with `flex-wrap` supported
        }
        else {
            // Either old Flexbox syntax, or `flex-wrap` not supported

        }
    }

    init();
})();


// Show update browser notification if IE<10, F<40, O<30, S<7 and C<40
var $buoop = {vs:{i:10,f:40,o:30,s:7,c:40},api:4};
function $buo_f(){
    var e = document.createElement("script");
    e.src = "//browser-update.org/update.min.js";
    document.body.appendChild(e);
};
try {document.addEventListener("DOMContentLoaded", $buo_f,false)}
catch(e){window.attachEvent("onload", $buo_f)}

// BOOTSTRAP BROWSER COMPATBILITY
// for IE10 in WP8
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var msViewportStyle = document.createElement('style')
    msViewportStyle.appendChild(
        document.createTextNode(
            '@-ms-viewport{width:auto!important}'
        )
    )
    document.head.appendChild(msViewportStyle)
}

// BOOTSTRAP BROWSER COMPATBILITY
// fix <select> on Android Stock browser
var nua = navigator.userAgent;
var is_android = ((nua.indexOf('Mozilla/5.0') > -1 && nua.indexOf('Android ') > -1 && nua.indexOf('AppleWebKit') > -1) && !(nua.indexOf('Chrome') > -1));
if(is_android) {
    $('select.form-control').removeClass('form-control').css('width', '100%');
}
